var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "466 266 28 28",
    style: {
      enableBackground: "new 466 266 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C9BD4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 480,
    cy: 280,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "480.6,271.1 484.7,273.4 480.6,275.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.9,280.5c0,3.8-3.1,6.8-6.9,6.8s-6.9-3.1-6.9-6.8c0-3.8,3.1-6.8,6.9-6.8v3.1l5.9-3.4L480,270v3.1 c-4.1,0-7.5,3.4-7.5,7.4c0,4.1,3.4,7.5,7.5,7.5s7.5-3.3,7.5-7.5H486.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcn);
export default __webpack_public_path__ + "static/media/refresh_icn.94746cbf4b6dd14c24960505df610ab5.svg";
export { ForwardRef as ReactComponent };